import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const ImagePlaceholderCompanyIcon: FC<IconProps> = ({  color = '#A0A1AD' }) => (
  <svg width='100%' height='100%' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='48' height='48' rx='8' fill='#E7E7EA' />
    <path fillRule='evenodd' clipRule='evenodd' d='M33.5993 16.8002H28.8002V14.4007C28.8002 13.7639 28.5471 13.1531 28.0971 12.7031C27.6471 12.2531 27.0362 12 26.3995 12H21.6004C20.2741 12 19.1998 13.0744 19.1998 14.4007V16.8002H14.4007C13.0743 16.8002 12 17.8746 12 19.1998V33.5993C12 34.2361 12.2531 34.8469 12.7031 35.2969C13.1531 35.7469 13.7639 36 14.4007 36H33.5993C34.2361 36 34.8469 35.7469 35.2969 35.2969C35.7469 34.8469 36 34.2361 36 33.5993V19.1998C36 18.5642 35.7469 17.9533 35.2969 17.5033C34.8469 17.0533 34.2361 16.8002 33.5993 16.8002H33.5993ZM21.6002 14.4007H26.4005V16.8002H21.6002V14.4007Z' fill={color} />
  </svg>
)

export default ImagePlaceholderCompanyIcon
